import React, { useState } from "react";
import { Link } from "react-router-dom";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import {
  FaBookOpen,
} from "react-icons/fa";

const booksData = [
  {
    category: "Classes 1st to 5th",
    publisher: "Madhuban Publication",
    publisherBadgeColor: "#8b5cf6",
    books: [
      "Mathematics",
      "Science",
      "Social Studies (SST)",
      "Environmental Studies (EVS)",
      "Hindi",
      "Punjabi",
      "English Reader",
      "English Grammar",
      "Drawing",
      "General Knowledge (GK)",
      "Moral Science",
    ],
  },
  {
    category: "Classes 6th to 8th",
    publisher: "Madhuban Publication",
    publisherBadgeColor: "#8b5cf6",
    books: [
      "English Language",
      "English Literature",
      "History & Civics",
      "Geography",
      "Physics",
      "Chemistry",
      "Biology",
      "Mathematics",
      "Hindi",
      "Punjabi",
      "General Knowledge (GK)",
      "Drawing",
      "Moral Values",
      "Financial Literacy",
    ],
  },
  {
    category: "Classes 9th & 10th",
    publisher: "Subject-Wise Authorized Publications",
    publisherBadgeColor: "#f4c842",
    detailedBooks: [
      { subject: "Science (Physics, Chemistry, Biology)", publisher: "Selina Publication" },
      { subject: "SST (History - Civics)", publisher: "Morning Star" },
      { subject: "English Language & Literature", publisher: "Evergreen Publication" },
      { subject: "Physical Education", publisher: "Blue Prints Publication" },
      { subject: "Mathematics", publisher: "Board Prescribed / NCERT" },
      { subject: "Hindi & Punjabi", publisher: "Board Prescribed" },
    ],
  },
  {
    category: "Nursery to UKG",
    publisher: "Madhuban Publication",
    publisherBadgeColor: "#22c55e",
    books: [
      "English Primer & Rhymes",
      "Hindi Akshar Abhyas",
      "Mathematics & Numbers",
      "EVS & General Awareness",
      "Art & Craft / Drawing",
    ],
  },
];

const Books = () => {
  const [openDropdown, setOpenDropdown] = useState(0); // Open first by default

  const toggle = (idx) =>
    setOpenDropdown((prev) => (prev === idx ? null : idx));

  return (
    <section className="relative min-h-screen pt-36 md:pt-40 pb-20 px-6 md:px-16 overflow-hidden bg-[#020810]">
      {/* Background ambient light */}
      <div
        className="absolute top-0 left-0 w-96 h-96 pointer-events-none"
        style={{
          background:
            "radial-gradient(circle, rgba(244,200,66,0.06) 0%, transparent 70%)",
        }}
      />

      <div className="max-w-4xl mx-auto relative z-10">
        {/* Back Link Only */}
        <div className="mb-6">
          <Link
            to="/information"
            className="inline-flex items-center gap-2 text-sm font-bold tracking-wide transition-colors hover:text-gold"
            style={{ fontFamily: "Nunito, sans-serif", color: "#f4c842" }}
          >
            ← Back to Information
          </Link>
        </div>

        <h1
          className="uppercase mb-4"
          style={{
            fontFamily: "Orbitron, sans-serif",
            fontWeight: 900,
            fontSize: "clamp(1.8rem, 4vw, 3rem)",
            color: "#f0f5ff",
          }}
        >
          Books & Curriculum
        </h1>
        <p className="text-gray-400 mb-8 text-base md:text-lg">
          Prescribed textbooks and publication details from Nursery to 10th Grade.
        </p>
        <div className="cosmic-divider mb-10" />

        <div className="space-y-4">
          {booksData.map((item, idx) => {
            const isOpen = openDropdown === idx;
            return (
              <div
                key={idx}
                className="glass-card rounded-2xl overflow-hidden transition-all duration-300 border border-white/10"
                style={{
                  borderColor: isOpen ? "#f4c84266" : "rgba(255,255,255,0.08)",
                  boxShadow: isOpen ? "0 4px 25px rgba(0,0,0,0.4)" : "none",
                }}
              >
                <button
                  className="w-full flex items-center justify-between px-6 py-5 text-left"
                  onClick={() => toggle(idx)}
                >
                  <div className="flex flex-wrap items-center gap-3 md:gap-4">
                    <div className="w-10 h-10 rounded-xl bg-gold/10 border border-gold/30 flex items-center justify-center text-gold flex-shrink-0">
                      <FaBookOpen size={18} />
                    </div>
                    <div>
                      <span
                        className="font-bold text-white text-lg block"
                        style={{ fontFamily: "Cinzel, serif" }}
                      >
                        {item.category}
                      </span>
                      <span
                        className="text-xs font-semibold px-2.5 py-0.5 rounded-full inline-block mt-1"
                        style={{
                          background: `${item.publisherBadgeColor}20`,
                          border: `1px solid ${item.publisherBadgeColor}50`,
                          color: item.publisherBadgeColor,
                        }}
                      >
                        {item.publisher}
                      </span>
                    </div>
                  </div>
                  <span className="text-gold text-xl ml-2">
                    {isOpen ? <IoIosArrowUp /> : <IoIosArrowDown />}
                  </span>
                </button>

                {isOpen && (
                  <div className="px-6 pb-6 pt-2 border-t border-white/5 bg-white/[0.02]">
                    {item.detailedBooks ? (
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mt-3">
                        {item.detailedBooks.map((b, bi) => (
                          <div
                            key={bi}
                            className="p-3.5 rounded-xl bg-white/5 border border-white/10 flex flex-col justify-between"
                          >
                            <span className="text-white font-semibold text-sm mb-1">
                              {b.subject}
                            </span>
                            <span className="text-xs text-gold font-medium">
                              Publication: {b.publisher}
                            </span>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div className="mt-3">
                        <p className="text-xs text-gray-400 mb-3 font-semibold uppercase tracking-wider">
                          Prescribed Subject List ({item.publisher}):
                        </p>
                        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-2.5">
                          {item.books.map((book, bi) => (
                            <div
                              key={bi}
                              className="px-3 py-2 rounded-lg bg-white/5 border border-white/10 text-gray-200 text-sm flex items-center gap-2"
                            >
                              <span className="w-1.5 h-1.5 rounded-full bg-gold flex-shrink-0" />
                              {book}
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Books;
